import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { MultiSelect } from "primereact/multiselect"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function ManageOrganizationIds({ field, block, index }) {
  const [organizationList, setOrganizationList] = useState([])
  const [visible, setVisible] = useState("block")
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_ORGANIZATION = gql`
    query getOrganization(
      $staff_id: ID!
      $organization_id: ID!
      $participant_membership_id: ID!
    ) {
      organization: activeOrganizations(staff_id: $staff_id) {
        key: organization_id
        label: organization_name
      }
      organizationsByMembershipId(
        staff_id: $staff_id
        organization_id: $organization_id
        participant_membership_id: $participant_membership_id
      ) {
        key: organization_id
        label: organization_name
      }
    }
  `
  const { loading } = useQuery(GET_ORGANIZATION, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      participant_membership_id: userCtx.participant_membership_id || "",
    },
    onCompleted: ({ organization, organizationsByMembershipId }) => {
      setOrganizationList(organization)
      formik.setFieldValue(field.field_name, organizationsByMembershipId)
    },
    skip: !userCtx,
  })

  useEffect(() => {
    if (block === "participant__manage_services") {
      const manageServicesType = formik?.getFieldProps("manage_services_type")
      setVisible("none")

      if (manageServicesType.value === "Share participant record") {
        setVisible("block")
      }
    } else {
      setVisible("block")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik])

  const handleSelectOrganizationIds = ({ e, form }) => {
    if (e.value === null) {
      form.setFieldValue(field.field_name, "")
    } else {
      form.setFieldValue(field.field_name, e.value)
    }
  }

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta, form }) => (
          <>
            <MultiSelect
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={(e) => handleSelectOrganizationIds({ e, form })}
              disabled={isDisabled}
              options={organizationList}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
